<template>
  <el-select
    v-model="whcode"
    @change="getCty"
    filterable
    clearable
    placeholder="请选择自提code"
    size="small"
  >
    <el-option
      v-for="(item,index) in options"
      :key="index"
      :label="item.code+'/'+item.zip"
      :value="item.code"
    ></el-option>
  </el-select>
</template>

<script>
import httpApi from "@/http/api";
export default {
  name: "whcode",
  props: {
    whcodes: { String }
  },
  data() {
    return {
      options: [], //国家列表
      whcode: this.whcodes
    };
  },
  methods: {
    getCty(e) {
      this.$emit("getCty", e);
    },
    init() {
      let that = this;
      httpApi
        .listUserParams({
          params: {
            type: "sys_wh",
            enable: "1"
          }
        })
        .then(res => {
          if (res.data.code == "ok") {
            that.options = res.data.data;
          }
        })
        .catch(() => {
          httpApi.listParams({
            params: { type: "sys_wh", enable: "1" }
          }).then(res => {
            if (res.data.code == "ok") that.options = res.data.data;
          });
        });
    }
  },
  created() {
    this.init();
  },
  watch: {
    whcodes: function(newVal) {
      this.whcode = newVal;
    }
  }
};
</script>

<style>
</style>